//Modules
import React, { useRef, useLayoutEffect, useContext } from 'react'
import { Icon } from '@iconify/react'
import { Link, useLocation } from 'react-router-dom'

//Components
import AgendaItem from './AgendaItem'
import AgendaCache from './AgendaCache.js'

//Utils
import { eventsContext } from '../../utils/UtilContext'
import '../../../script/timeline.min.js' //https://github.com/squarechip/timeline

const Agenda = () => {
    const { agendaItems, loading, isError } = useContext(eventsContext)

    const $ = window.$
    const elmt = useRef()

    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)

    let history = useLocation()
    const lang = history.pathname.substring(1,3)

    useLayoutEffect(() => {
        const $elmt = $(elmt.current)

        $elmt.timeline({
            mode: 'horizontal',
            visibleItems: 4,
            forceVerticalMode: 1024,
            rtlMode: false
          })
    })

    let agendaFilter = ((!loading || agendaItems !== null) && Array.isArray(agendaItems)) &&
        agendaItems.filter((agendaItem) => {
            if (agendaItem.destaque === "1" && (new Date(agendaItem.data_inicio) >= yesterday || new Date(agendaItem.data_fim) >= yesterday)) {
            return agendaItem
            } else {
            return false
            }
        })

    return (
        <>        
           {((!loading || agendaItems !== null) && Array.isArray(agendaItems)) ?
            <>
                 <div className="timeline" ref={elmt}>
                    <div className="timeline__wrap">
                        <div className="timeline__items">
                            {agendaFilter.slice(0).reverse().map((agendaItem) => (
                                <AgendaItem key={agendaItem.event_id} agendaItem={agendaItem} lang={lang} />
                            ))}                         
                        </div>
                    </div>
                </div>                
            </> 
            : 
            <div>
                {isError || agendaItems !== null ?
                    <AgendaCache elmt={elmt} lang={lang} />
                :
                    <Icon style={{fontSize: '3rem'}} icon="svg-spinners:ring-resize" />
                }
            </div>
           }
        </>
    )
}

export default Agenda
